export default "__VITE_ASSET__CNF9g945__"